if (!customElements.get('hot-deal-timer')) {
  customElements.define('hot-deal-timer', class HotDealTimer extends HTMLElement {
    connectedCallback() {
      const end = new Date(this.dataset.end).getTime();
      const parts = {
        days: this.querySelector('[data-part="days"]'),
        hours: this.querySelector('[data-part="hours"]'),
        minutes: this.querySelector('[data-part="minutes"]'),
        seconds: this.querySelector('[data-part="seconds"]')
      };
      const pad = n => n.toString().padStart(2, '0');
      const update = () => {
        const now = Date.now();
        const d = end - now;
        if (d <= 0) { Object.values(parts).forEach(el => el.textContent = '00'); clearInterval(this._t); return; }
        const days = Math.floor(d / (1000*60*60*24));
        const hrs = Math.floor((d % (1000*60*60*24)) / (1000*60*60));
        const mins = Math.floor((d % (1000*60*60)) / (1000*60));
        const secs = Math.floor((d % (1000*60)) / 1000);
        parts.days.textContent = pad(days);
        parts.hours.textContent = pad(hrs);
        parts.minutes.textContent = pad(mins);
        parts.seconds.textContent = pad(secs);
      };
      update();
      this._t = setInterval(update, 1000);
    }
    disconnectedCallback() { clearInterval(this._t); }
  });
}
